import { MAX_HISTORICAL_ELEMENTS } from '@/constants/store/constants';

const mutations = {
  createElement: (state, element) => {
    state.elements = state.elements.concat([element]);
  },

  updateElement: (state, element) => {
    const elementIndex = state.elements.findIndex(e => e.elementId === element.elementId);
    if (elementIndex !== -1) {
      element.receptor = element.receptor || state.elements[elementIndex].receptor;
      element.recording = element.recording || state.elements[elementIndex].recording;
      state.elements.splice(elementIndex, 1, element);
    }
  },

  deleteElement: (state, elementId) => {
    state.elements = state.elements.filter(element => element.elementId !== elementId);
  },

  deleteElementsForInteraction: (state, interactionId) => {
    state.elements = state.elements.filter(element => element.interactionId !== interactionId);
  },

  deleteHistoricalElementsForInteraction: (state, interactionId) => {
    state.history = state.history.filter(element => element.interactionId !== interactionId);
  },

  deleteClosedElementsForInteraction: (state, interactionId) => {
    state.history = state.history.filter(element => element.interactionId !== interactionId && element.isCloned);
  },

  createHistoricalElement: (state, element) => {
    state.history = state.history.concat([element]);
    if (state.history.length > MAX_HISTORICAL_ELEMENTS) {
      state.history = state.history.slice(-MAX_HISTORICAL_ELEMENTS);
    }
  },

  setElementAnsweredAt: (state, { elementId, answeredAt }) => {
    state.elementAnsweredAt[elementId] = answeredAt;
  },

  unsetElementAnsweredAt: (state, elementId) => {
    delete state.elementAnsweredAt[elementId];
  },

  clearInactiveElementsAnsweredAt: (state, elementIds) => {
    const storedAnsweredAtElementIds = structuredClone(state.elementAnsweredAt);
    state.elementAnsweredAt = {};
    elementIds.forEach(elementId => {
      state.elementAnsweredAt[elementId] = storedAnsweredAtElementIds[elementId];
    });
  },

  setElementContactInformationForEmail: (state, payload) => {
    const elementIndex = state.elements.findIndex(e => e.elementId === payload.elementId);
    if (elementIndex !== -1) {
      const element = state.elements[elementIndex];
      element.receptor = { ...element.receptor, id: payload.contactId, name: payload.name };
      state.elements.splice(elementIndex, 1, element);
    }
  }
};

export default {
  ...mutations
};
